import * as api from "@/api/williams/tests";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useTestLookup(search: string, contractorId?: string) {
  return useQuery([...queryKeys.standardTests.search(search), contractorId], () => {
    return api.getStandardTestLookup(search, contractorId);
  });
}
